export default __webpack_public_path__ + "static/bg_subscription-b798b9839699ac37923b2ed6cf7fce8e.png";